import React from 'react';
import styles from '../pages/assets/css/DetailDashboard.module.css';

/** Page numbers to show: first, last, and a window around the current page. */
const pageWindow = (current, total) => {
  const pages = new Set([1, total, current - 1, current, current + 1]);
  const sorted = [...pages].filter((page) => page >= 1 && page <= total).sort((a, b) => a - b);
  return sorted.flatMap((page, index) => (index && page - sorted[index - 1] > 1 ? ['…', page] : [page]));
};

/** "Showing x–y of n" with Previous, numbered pages and Next. */
const Pagination = ({ page, pageSize, total, loading = false, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const firstRow = total ? (page - 1) * pageSize + 1 : 0;
  const lastRow = Math.min(page * pageSize, total);

  return (
    <div className={styles.paginationBar}>
      <span className={styles.muted}>{loading ? 'Loading…' : `Showing ${firstRow}–${lastRow} of ${total}`}</span>
      <div className={styles.pageButtons}>
        <button
          type="button"
          className={styles.secondaryButton}
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1 || loading}
        >
          Previous
        </button>
        {pageWindow(page, totalPages).map((item, index) => (
          item === '…'
            ? <span key={`gap-${index}`} className={styles.muted}>…</span>
            : (
              <button
                type="button"
                key={item}
                className={item === page ? styles.primaryButton : styles.secondaryButton}
                onClick={() => onPageChange(item)}
                disabled={loading}
                aria-current={item === page ? 'page' : undefined}
              >
                {item}
              </button>
            )
        ))}
        <button
          type="button"
          className={styles.secondaryButton}
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages || loading}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
